import { render, staticRenderFns } from "./ClassTab.vue?vue&type=template&id=c0e6c524&scoped=true"
import script from "./ClassTab.vue?vue&type=script&lang=js"
export * from "./ClassTab.vue?vue&type=script&lang=js"
import style0 from "./ClassTab.vue?vue&type=style&index=0&id=c0e6c524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e6c524",
  null
  
)

export default component.exports